module.exports = __webpack_public_path__ + "static/logo_b-b7133076a87653658e34eead224cc5ab.svg";